<template>
    <div class="setting-content--section">
        <InviteListModal v-if="showInviteModal" @close-modal="showInviteModal = false" :pendingInvites="pendingInvites" />
        <b-alert v-if="noCompanyFlag" show variant="danger" class="mb-4">
            <span v-translate>There is no company profile attached to this account. To continue, you either need to create a new company profile of your own, or ask someone to send an invite link to another company profile you can collaborate on.</span>
        </b-alert>
        <b-form  @submit="onSubmit">
            <b-form-group id="input-group-1" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Logo')" label-for="input-1">
                <VueDropzone :preloaded_file="imageSrc" :allowed-files="'all'" :onlyChange="true" @change="fileChanged"></VueDropzone>
            </b-form-group>
            <b-form-group id="input-group-1" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Name') + '*'" label-for="input-1" :description="$gettext('Name of your company.')">
                <b-form-input id="input-1" v-model="form.name" required :placeholder="$gettext('Enter company name')" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-2" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Type of business entity')" label-for="input-2">
                <b-form-select id="input-2" v-model="form.legal_form" :options="entities" value-field="key" text-field="value" @change="onFormChange"></b-form-select>
            </b-form-group>
            <b-form-group id="input-group-3" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Sector') + '*'" label-for="input-3">
                <b-form-select id="input-3" v-model="form.sector" :options="sectors" required value-field="key" text-field="value" @change="onFormChange">
                    <template #first>
                        <b-form-select-option :value="null" >---------</b-form-select-option>
                    </template>
                </b-form-select>
            </b-form-group>
            <b-form-group id="input-group-4" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Company Description')" label-for="input-4">
                <b-form-textarea id="input-4" v-model="form.description" :placeholder="$gettext('Enter a description here...')" rows="3" @change="onFormChange"></b-form-textarea>
            </b-form-group>
            <b-form-group id="input-group-5" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Address')" label-for="input-5">
                <b-form-input id="input-5" v-model="form.address" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-6" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Postal Code')" label-for="input-6">
                <b-form-input id="input-6" v-model="form.postal_code" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-7" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('City')" label-for="input-7">
                <b-form-input id="input-7" v-model="form.city" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-8" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Country') + '*'" label-for="input-8">
                <b-form-select id="input-8" v-model="form.country" :options="countries" @change="onFormChange" required></b-form-select>
            </b-form-group>
            <b-form-group v-if="states" id="input-group-20" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('State')" label-for="input-20">
                <b-form-select id="input-20" v-model="form.administrative_area" :options="states" value-field="key" text-field="value" @change="onFormChange" />
            </b-form-group>
            <b-form-group id="input-group-9" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Phone number')" label-for="input-9">
                <b-form-input id="input-9" v-model="form.phone_number" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-10" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin">
                <b-form-checkbox id="input-10" class="checkbox-bg-color" v-model="form.phone_number_show_on_invoice" @change="onFormChange" switch><span v-translate>Show phone number on invoice</span></b-form-checkbox>
            </b-form-group>
            <b-form-group id="input-group-11" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Email')" label-for="input-11" :description="$gettext('Invoices will be sent from this e-mail address.')">
                <b-form-input id="input-11" v-model="form.email" type="email" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-13" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('VAT identification number')" label-for="input-13">
                <b-form-input id="input-13" v-model="form.btw" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-14" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin">
                <b-form-checkbox id="input-14" class="checkbox-bg-color" v-model="form.btw_show_on_invoice" @change="onFormChange" switch><span v-translate>Show VAT identification number on invoice</span></b-form-checkbox>
            </b-form-group>
            <b-form-group id="input-group-15" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Bank name')" label-for="input-15">
                <b-form-input id="input-15" v-model="form.bank_name" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-16" label-cols-sm="3" label-align-sm="right" content-cols-md="5"  label-class="gk-label-margin" :label="$gettext('Bank account number')" label-for="input-16">
                <b-form-input id="input-16" v-model="form.bank_account_number" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-19" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" label="" label-for="input-19">
                <div style="display: flex; gap: 1rem; justify-content: space-between;">
                    <GekkoButton v-if="noCompanyFlag" :text="$gettext('Logout')" :to="{ name: 'Logout' }" variant="outline-danger" />
                    <GekkoButton :text="$gettext('Create')" type="submit" :loading="isWaitingForResponse" />
                </div>
            </b-form-group>

        </b-form>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";

// @ is an alias to /src
import CompanyService from "@/store/services/company.service.js";
import UserInviteService from "@/store/services/userinvite.service"
import VueDropzone from "@/components/VueDropzone";
import GekkoButton from "@/components/GekkoButton";
import InviteListModal from "@/components/team/InviteListModal";

// mixins
import settingsPageSetup from "@/mixins/settingsPageSetup";

export default {
    name: "CreateCompany",
    components: {
        VueDropzone, GekkoButton, InviteListModal
    },
    mixins: [settingsPageSetup],
    data() {
        return {
            pageSettings: {
                title: this.$gettext("Create a company"),
                showCompanyPicker: false
            },
            formChanged: false,
            form: {
                address: '',
                bank_account_number: '',
                bank_name: '',
                btw: '',
                btw_show_on_invoice: false,
                city: '',
                country: 'NL',
                description: '',
                email: '',
                kvk: '',
                legal_form: '',
                logo: null,
                name: '',
                phone_number: '',
                phone_number_show_on_invoice: false,
                postal_code: '',
                sector: ''
            },
            states: null,
            entities: [],
            sectors: [],
            countries: [],
            imageSrc: '',
            showInviteModal: false,
            pendingInvites: [],
            noCompanyFlag: false
        }
    },
    created(){
        var vm = this;
        CompanyService.getBusinessEntities().then(function(response){
            vm.entities = response.data[vm.form.country.toLowerCase()];
        });
        CompanyService.getSectors().then(function(response){
            vm.sectors = response.data;
        });
        CompanyService.getCountries().then(function(response){
            vm.countries = response.data;
        });
        this._fetchStates();

        if (Object.keys(this.currentCompany).length === 0 && this.currentCompany.constructor === Object) {
            CompanyService.list().then((response) => { // check if there's an avaiable company and the local storage doesn't have it set
                if (response.data.length === 0) {
                    this.noCompanyFlag = true;
                }
                if ((response.data.length > 0 && localStorage.getItem('company_id') === 'null') || (response.data.length > 0 && !response.data.find(item => item.id == localStorage.getItem('company_id'))))  {
                    localStorage.setItem('company_id', response.data[0].id)
                    window.location.href = window.Urls['gekko_dashboard']()
                }
            })
            
            UserInviteService.listInvites().then((response) => {
                if (response.data.length > 0) {
                    this.showInviteModal = true;
                    this.pendingInvites = response.data;
                    console.log('pendingInvites', this.pendingInvites);
                }
            })            
        }
    },
    computed: {
        ...mapGetters({
            isWaitingForResponse: 'main/isWaitingForResponse',
            currentCompany: 'main/getCurrentCompany',
            currentUser: 'main/getCurrentUser'
        })
    },
    methods: {
        ...mapActions({ 
            switchCompany: 'main/switchCompanyProfile',
            loadMainGlobalData: "main/loadMainGlobalData",
            loadCurrentCompany: "main/loadCurrentCompany"
        }),
        _fetchStates() {
            CompanyService.getStates({country: this.form.country}).then((response) => {
                if (response.data.length === 0) {
                    this.states = null;
                } else {
                    this.states = response.data;
                    this.states.unshift({key: '', value: '---------'});
                }
            })
        },
        ...mapMutations({
            setWaitingForResponse: 'main/SET_WAITING_FOR_RESPONSE'
        }),
        onSubmit(e) {
            e.preventDefault()
            this.setWaitingForResponse(true)
            let noCompanyFlag = false
            if (Object.keys(this.currentCompany).length === 0 && this.currentCompany.constructor === Object) noCompanyFlag = true
            if (!this.form.logo || this.form.logo === '') {
                delete this.form.logo
            }
            
            CompanyService.create(this.form).then((response) => {
                if (noCompanyFlag) {
                    localStorage.setItem('company_id', response.data.id)
                    window.location.href = '/dashboard' // must redirect this way to switch into Gekko app
                } else {
                    this.redirect(response.data.id)
                }
            }).catch((error) => {
                if (error.status === 403) {
                    this.$store.commit('togglePremiumModal', 'web_companies');
                }
            }).finally(() => {
                this.setWaitingForResponse(false)
            });
        },
        redirect(target_company){
            this.switchCompany(target_company).then(() => {
                this.$router.push({ name: 'CompanySettings' }).catch(() => {})
            })
        },
        fileChanged(file){
            this.form.logo = file;
        },
        onFormChange(){
            this.formChanged = true;
            this._fetchStates();
        }
    },
    beforeRouteLeave (to, from , next) {
      var answer = true;
      if(this.formChanged){
        answer = window.confirm(this.$gettext('You made changes that have not yet been saved. Are you sure you want to continue and discard those changes?'))
      }
      if (answer) {
        next()
      } else {
        next(false)
      }
    }
};
</script>
<style >
.checkbox-bg-color .custom-control-input:checked ~ .custom-control-label::before{
    border-color: #0575ff;
    background-color: #0575ff;
}

.float-alert-top{
    position: fixed !important;
    top: 50px;
    right: 15%;
    z-index: 1000;
}
</style>
